module.exports = __webpack_public_path__ + "static/media/crown.2347b96a.png";